import { render, staticRenderFns } from "./Conntect.vue?vue&type=template&id=51974001&scoped=true&"
import script from "./Conntect.vue?vue&type=script&lang=js&"
export * from "./Conntect.vue?vue&type=script&lang=js&"
import style0 from "./Conntect.vue?vue&type=style&index=0&id=51974001&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51974001",
  null
  
)

export default component.exports